import { callApi, callApiFileStorage } from "./service";
import swal from "sweetalert";
import { metaPixelService } from "./metaPixel.service";
import { setToken } from "../hooks/authHook";

export const userService = {
    externalLogin,
    login,
    logout,
    forgotPassword,
    resetPassword,
    editProfile,
    updateStyle,
    validateEmailAccount,
    register,
    verifyAccount
};

/**
 *  External
 */
async function externalLogin(params) {
  return callApi("/externalAuth/Login", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    if (result.responseCode === "00") setToken(result.data);

    return result;
  });
}


/**
 * Login
 */
async function login(params) {
  return callApi("/Auth/Login", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    if (result.responseCode === "00") setToken(result.data);
    return result;
  });
}

/**
 * Logout
 */
async function logout() {
  localStorage.removeItem("_rtpride");
  localStorage.removeItem("_tpride");
  localStorage.removeItem("userId");
  localStorage.removeItem("roleName");
  localStorage.removeItem("isFirstTime"); //use for notifications
}

/*
 Send email to recovery password
 */
async function forgotPassword(params) {
  return callApi("/Auth/ForgotPassword", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    if (result.responseCode === "00") {
      return true;
    } else {
      swal({ text: result.responseMessage, icon: "error" });
    }
  });
}

async function validateEmailAccount(params) {
  return callApi("/Auth/ValidateEmailAccount", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    if (result.responseCode === "00") {
      return result.data;
    } else {
      console.warn(result.responseMessage);
      return result.responseMessage;
    }
  });
}

/*
 Set the new user password
 */
async function resetPassword(params) {
  return callApi("/Auth/ResetPassword", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    if (result.responseCode === "00") {
      return result;
    } else {
      return result;
    }
  });
}

async function editProfile(data, companyId) {
  const formData = new FormData();

  formData.append("CompanyId", companyId);
  formData.append("ProfileImage", data?.urlProfileImage ?? null);

  if (data?.GenderIdentityId && data.GenderIdentityId !== 0) {
    formData.append("GenderIdentityId", data.GenderIdentityId);
    formData.append("GenderIdentityFlag", data.GenderIdentityFlag);
  }

  const appendWithFallback = (key, value) => {
    const fallback = "a5cdc20f-c8fe-48df-be43-fc56f43a198a";
    if (value != null && value !== "undefined") {
      formData.append(key, value.trim() === "" ? fallback : value);
    }
  };

  appendWithFallback("nickname", data?.nickname);
  appendWithFallback("additionalEmail", data?.additionalEmail);

  if (data?.Notification != null) {
    formData.append("Notification", data.Notification);
  }

  if (data?.Preferences != null) {
    formData.append("Preferences", data.Preferences);
  }

  if (data?.Mobile != null) {
    formData.append("Mobile", data.Mobile);
  }

  if (data?.birthday != null) {
    formData.append("birthday", data.birthday);

  }

  if (data?.pronoun != null) {
    formData.append("pronoun", data.pronoun);
  }

  if (data?.firstName != null) {
    formData.append("firstName", data.firstName);
  }

  if (data?.lastName != null) {
    formData.append("lastName", data.lastName);
  }

  if (data?.currentPassword != null) {
    formData.append("currentPassword", data.currentPassword);
  }

  if (data?.newPassword != null) {
    formData.append("newPassword", data.newPassword);
  }

  try {
    const result = await callApiFileStorage("/Account/EditProfile", "POST", formData, false);
    if (result.responseCode === "00")
      return { success: true, msg: "Tu perfil fue actualizado exitosamente" };
    if (result.responseCode === "99")
      return { success: false, msg: "El campo contraseña actual es incorrecta" };

  } catch (error) {
    console.error("Error en editProfile:", error);
    await swal({text: "Error al actualizar el perfil.", icon: "error"});
    return false;
  }
}

async function updateStyle(data){

    return callApi('/Account/UpdateColor', 'POST', data,{
        SkipValidationToken: true,
      })
        .then((result) => {
            if (result.responseCode === "00") {                
                return true;
            } else {
                swal({ text: result.responseMessage, icon: "error" });
                return false;
            }
        });
}
function currentURL() {
  return window.location.href
}
function getUserAgent() {
  return window.navigator.userAgent;
}

async function register(model) {
  const result = await callApi("/Auth/Register", "POST", model, {
    SkipValidationToken: true,
  });

  if (result.responseCode === "00") {
    const pixelUserInfoObj = JSON.parse(result.data);
    const registerPixelUserInfo = pixelUserInfoObj.RegisterPixelUserInfo;
    registerPixelUserInfo.client_user_agent = getUserAgent();
    const ped = { content_name: "Registro" };
    const pixelData = {
      pixelUserInfo: registerPixelUserInfo,
      pixelCustomData: ped,
    };

    if (typeof window.fbq === "function") {
      metaPixelService.trackEvent('track', 'CompleteRegistration', pixelData, currentURL());
    } else {
      console.warn("Facebook Pixel not ready");
    }

    return { success: true, msg: "" };
  } else {
    return { success: false, msg: result.responseMessage };
  }
}

async function verifyAccount(params) {
  return callApi("/Auth/VerifyAccount", "POST", params, {
    SkipValidationToken: true,
  }).then((result) => {
    //WelcomeMessage();
    return result;
  });
}
